import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-payment-register-monthwise',
  templateUrl: './payment-register-monthwise.component.html',
  styleUrl: './payment-register-monthwise.component.scss'
})
export class PaymentRegisterMonthwiseComponent {

   constructor(
      private dialogRef: MatDialogRef<PaymentRegisterMonthwiseComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
    ) {
    }
  


  advtMonthwiseFormBeans: any = []
  reportType:any
  startDate :any
  endDate :any
  repName :any
  offRepName:any
  advtName :any
  issueDates:any
  issueDates1:any

PaymentReceiptRegister = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    rep_name: new FormControl(),
    off_rep_name: new FormControl(),
    issuename: new FormControl(),
    issueDates:new FormControl(),
  });
  startDate_contract: any;
  enddate_contract: any;
  advtMonthwiseTotal: number = 0;
  ngOnInit(): void {

debugger
let repname: any = this.data['repName'];

    // Then check if it's not empty and convert to array
    if (repname != "") {
      repname = repname; // This puts the single value in an array
    }

    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'];
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];


    const req: any = {
      "rep_name": repname,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "advt_name": this.data['name'],
      // // "issue_name" : this.advtName,
      // "issue_date": this.issueDates
      "issue_name": "",
      "issue_date": this.issueDates
  
  
    }


  this.service.getAdvtMonthwise(req).subscribe((data: any) => {
    console.log("ADVT Data=", data);
    this.advtMonthwiseFormBeans = (data as any);;
    // Reset totals
    this.advtMonthwiseTotal = 0;

    // Calculate totals
    for (let data of this.advtMonthwiseFormBeans) {

      this.advtMonthwiseTotal += parseFloat(data.rcv_amt) || 0;
    }
  });

}

exportExcel(fileName): void {
  console.log('Export function called with fileName:', fileName);
  
  let element = document.getElementById('print-section');
  console.log('Element found:', element);
  
  if (!element) {
    console.error('Element with ID "print-section" not found in DOM');
    return;
  }
  
  try {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    console.log('Worksheet created:', ws);
    
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
    XLSX.writeFile(wb, fileName + '.xlsx');
    console.log('File should be downloaded');
  } catch (error) {
    console.error('Error during export:', error);
  }
}

show = false;
 
//    printPageA4Portrait() {
 
//            this.show = true;
//            const printSection = document.getElementById('print-section');
//            if (!printSection) {
//                console.error("Print section not found!");
//                return;
//            }
         
//            const printContent = printSection.innerHTML;
         
//            const screenWidth = window.screen.availWidth;
//            const windowWidth = 1000;
//            const leftPosition = screenWidth - windowWidth - 50;
         
//            const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
         
//            if (printWindow) {
//                printWindow.document.open();
//                printWindow.document.write(`
//                    <html>
//                        <head>
//                            <title>Print Report</title>
//                            <style>
//                                @media print {
//                                    @page {
//                                        size: A4 portrait;
//                                        margin: 5mm;
//                                    }
//                                    body {
//                                        font-family: Arial, sans-serif;
//                                        margin: 0;
//                                        padding: 0;
//                                        font-size: 9px !important;
//                                    }
//                                    .print-section {
//                                        width: 40%;
//                                        margin: 0 auto;
                                       
//                                        padding: 0;
//                                    }
//                                    table {
//                                        width: auto !important;
//                                        border-collapse: collapse;
//                                        table-layout: auto;
//                                        page-break-inside: auto;
//                                        border: 1px solid black !important;
//                                    }
//                                    tr {
//                                        page-break-inside: avoid;
//                                        page-break-after: auto;
//                                    }
//                                    th, td {
//                                        padding: 2px 3px !important;
//                                        border: 1px solid black !important;
//                                        font-size: 9px;
//                                        line-height: 1.2;
//                                        white-space: nowrap;
//                                    }
//                                    th {
//                                        background-color: #f2f2f2;
//                                        font-weight: bold;
//                                    }
//                                    tr {
//                                        border-bottom: 1px solid black !important;
//                                    }
//                                    tr.header-row {
//                                        display: table-header-group;
//                                    }
//                                    td[data-type="number"],
//                                    td.amount,
//                                    td.balance-value,
//                                    td:nth-child(n+12) {
//                                        text-align: right !important;
//                                    }
//                                    td.text,
//                                    td[data-type="string"] {
//                                        text-align: left !important;
//                                    }
//                                    .br-right { border-right: 1px solid black !important; }
//                                    .br-rightt { border-right: 4px solid black !important; }
//                                    .br-bottom { border-bottom: 1px solid black !important; }
//                                    .br-top { border-top: 1px solid black !important; }
//                                    .noPrint { display: none !important; }
//                                    .footer-line {
//                                        position: fixed;
//                                        bottom: 0;
//                                        left: 0;
//                                        width: 40%;
//                                         margin: 0 auto; /* ✅ Centers the table horizontally */
//                                        height: 1px;
//                                        background-color: black;
//                                    }
//                                    thead { 
//                                        display: table-header-group; 
//                                        border: 1px solid black !important;
//                                    }
//                                    tfoot { 
//                                        display: table-footer-group; 
//                                        border: 1px solid black !important;
//                                    }
//                                    /* Ensure all borders are displayed */
//                                    table, th, td {
//                                        border-style: solid !important;
//                                        border-width: 1px !important;
//                                        border-color: black !important;
//                                    }
//                                    /* Make sure header repeats on each page */
//                                    thead tr {
//                                        display: table-row !important;
//                                    }
//                                }
//                            </style>
//                        </head>
//                        <body>
//                            <div class="print-section">
//                                ${printContent}
//                                <div class="footer-line"></div>
//                            </div>
//                            <script>
//                               window.onload = function () {
//                                   const table = document.querySelector('table');
//                                   if (!table) {
//                                       console.error("Table not found");
//                                       return;
//                                   }
       
//                                   // Auto-size columns based on content
//                                   table.style.width = 'auto';
//                                   const cols = table.querySelectorAll('td, th');
//                                   cols.forEach(cell => {
//                                       cell.style.width = 'auto';
//                                       cell.style.whiteSpace = 'nowrap';
//                                   });
       
//                                   let headerRowIndex = -1;
//                                   const maxRowsToCheck = Math.min(10, table.rows.length);
       
//                                   // Find header row with column names
//                                   for (let i = 0; i < maxRowsToCheck; i++) {
//                                       const row = table.rows[i];
//                                       const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());
       
//                                       if (row.cells.length >= 8 &&
//                                           (cellTexts.includes('Invoice No') ||
//                                            cellTexts.includes('Receipt No') ||
//                                            cellTexts.includes('Balance'))) {
//                                           headerRowIndex = i;
//                                           break;
//                                       }
//                                   }
       
//                                   if (headerRowIndex >= 0) {
//                                       // Create thead and move only the actual header row into it
//                                       let thead = table.querySelector('thead');
//                                       if (!thead) {
//                                           thead = document.createElement('thead');
//                                           table.insertBefore(thead, table.firstChild);
//                                       }
       
//                                       const headerRow = table.rows[headerRowIndex];
//                                       thead.appendChild(headerRow.cloneNode(true));
//                                   }
       
//                                   // Alignment processing
//                                   const cells = document.querySelectorAll('td');
//                                   cells.forEach(cell => {
//                                       const content = cell.textContent.trim();
       
//                                       if (content.includes('येणे') ||
//                                           content.includes('Opening Balance') ||
//                                           content.match(/^\\d+\\s+येणे$/) ||
//                                           content.includes('Balance C/F') ||
//                                           content.includes('Total')) {
//                                           cell.style.textAlign = 'right';
//                                           cell.classList.add('balance-value');
//                                       }
       
//                                       const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
//                                       if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
//                                           cell.style.textAlign = 'right';
//                                           cell.classList.add('amount');
//                                       }
       
//                                       cell.style.border = '1px solid black';
//                                   });
       
//                                   setTimeout(() => {
//                                       window.print();
//                                       setTimeout(() => { window.close(); }, 500);
//                                   }, 200);
//                               };
//                            </script>
//                        </body>
//                    </html>
//                `);
//                printWindow.document.close();
//            } else {
//                console.error("Failed to open print window.");
//            }
//        }


// printPageA4Portrait() {
//     this.show = true;
//     const printSection = document.getElementById('print-section');
//     if (!printSection) {
//         console.error("Print section not found!");
//         return;
//     }
  
//     const printContent = printSection.innerHTML;
  
//     const screenWidth = window.screen.availWidth;
//     const windowWidth = 1000;
//     const leftPosition = screenWidth - windowWidth - 50;
  
//     const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
  
//     if (printWindow) {
//         printWindow.document.open();
//         printWindow.document.write(`
//             <html>
//                 <head>
//                     <title>Print Report</title>
//                     <style>
//                         @media print {
//                             @page {
//                                 size: A4 portrait;
//                                 margin: 10mm;
//                             }
//                             body {
//                                 font-family: Arial, sans-serif;
//                                 margin: 0;
//                                 padding: 0;
//                                 font-size: 10px !important;
//                             }
//                             .print-section {
//                                 width: 100%;
//                                 margin: 0;
//                                 padding: 0;
//                             }
                            
//                             /* Header Styles */
//                             h1, h2, h3 {
//                                 text-align: center;
//                                 margin: 5px 0;
//                             }
                            
//                             h1 {
//                                 font-size: 18px;
//                                 font-weight: bold;
//                             }
                            
//                             h2 {
//                                 font-size: 14px;
//                                 font-weight: normal;
//                             }
                            
//                             .date-range {
//                                 text-align: right;
//                                 font-size: 10px;
//                                 margin: 10px 0;
//                             }
                            
//                             table {
//                                 width: 100% !important;
//                                 border-collapse: collapse;
//                                 margin: 20px 0;
//                                 page-break-inside: auto;
//                             }
                            
//                             tr {
//                                 page-break-inside: avoid;
//                                 page-break-after: auto;
//                             }
                            
//                             th, td {
//                                 padding: 8px 10px !important;
//                                 border: 1px solid #333 !important;
//                                 font-size: 10px;
//                                 line-height: 1.4;
//                             }
                            
//                             th {
//                                 background-color: #b8e6e1 !important;
//                                 font-weight: bold;
//                                 text-align: center;
//                                 -webkit-print-color-adjust: exact;
//                                 print-color-adjust: exact;
//                             }
                            
//                             td {
//                                 text-align: center;
//                             }
                            
//                             /* Column alignment */
//                             td:nth-child(2) {
//                                 text-align: right !important;
//                             }
                            
//                             /* Total row styling */
//                             tr:last-child td {
//                                 background-color: #f9f3d8 !important;
//                                 font-weight: bold;
//                                 -webkit-print-color-adjust: exact;
//                                 print-color-adjust: exact;
//                             }
                            
//                             .br-right { border-right: 1px solid black !important; }
//                             .br-rightt { border-right: 4px solid black !important; }
//                             .br-bottom { border-bottom: 1px solid black !important; }
//                             .br-top { border-top: 1px solid black !important; }
//                             .noPrint { display: none !important; }
                            
//                             thead { 
//                                 display: table-header-group; 
//                             }
                            
//                             tfoot { 
//                                 display: table-footer-group; 
//                             }
                            
//                             /* Ensure thead repeats on each page */
//                             thead tr {
//                                 display: table-row !important;
//                             }
//                         }
                        
//                         /* Screen preview styles */
//                         @media screen {
//                             body {
//                                 font-family: Arial, sans-serif;
//                                 padding: 20px;
//                                 background: white;
//                             }
                            
//                             .print-section {
//                                 max-width: 100%;
//                             }
                            
//                             h1 {
//                                 text-align: center;
//                                 font-size: 24px;
//                                 margin: 10px 0;
//                             }
                            
//                             h2 {
//                                 text-align: center;
//                                 font-size: 16px;
//                                 margin: 5px 0;
//                             }
                            
//                             h3 {
//                                 color: #0066cc;
//                                 font-size: 14px;
//                                 margin: 15px 0 10px 0;
//                             }
                            
//                             .date-range {
//                                 text-align: right;
//                                 font-size: 12px;
//                                 margin: 10px 0;
//                             }
                            
//                             table {
//                                 width: 100%;
//                                 border-collapse: collapse;
//                                 margin: 20px 0;
//                             }
                            
//                             th, td {
//                                 padding: 10px;
//                                 border: 1px solid #333;
//                                 text-align: center;
//                             }
                            
//                             th {
//                                 background-color: #b8e6e1;
//                                 font-weight: bold;
//                             }
                            
//                             td:nth-child(2) {
//                                 text-align: right;
//                             }
                            
//                             tr:last-child td {
//                                 background-color: #f9f3d8;
//                                 font-weight: bold;
//                             }
//                         }
//                     </style>
//                 </head>
//                 <body>
//                     <div class="print-section">
//                         ${printContent}
//                     </div>
//                     <script>
//                        window.onload = function () {
//                            setTimeout(() => {
//                                window.print();
//                                setTimeout(() => { window.close(); }, 500);
//                            }, 200);
//                        };
//                     </script>
//                 </body>
//             </html>
//         `);
//         printWindow.document.close();
//     } else {
//         console.error("Failed to open print window.");
//     }
// }
}
